import { ReactNode } from 'react'

import { CommonInfoWarning } from '@/icons'

import { Text } from './text'

export const Warning = ({ msg, icon }: { msg: string; icon?: ReactNode }) => {
  if (!msg) return null
  return (
    <div className='flex gap-3 rounded-sm bg-main-12 py-3 px-4 ring-[1px] md:ring-[0.5px] [@media(max-resolution:1.9dppx)]:ring-[1px] ring-main-80'>
      <div>{icon || <CommonInfoWarning className='size-4 md:size-6' />}</div>
      <Text color='main' className='flex items-center'>
        {msg}
      </Text>
    </div>
  )
}
